import {
  Box,
  Checkbox,
  Icon,
  Text,
  Tooltip,
  useToggle,
} from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { MultipleChoiceAnswerProps } from 'modules/form_answers/lib/types'

export const MultipleChoiceAnswer: React.FC<MultipleChoiceAnswerProps> = ({
  selectedOptions,
  options,
  mandatory,
}) => {
  const [openTooltip, setOpenTooltip] = useToggle(false)

  return (
    <Box flexDirection="column" gap="s16">
      <Text.Normal size="200">
        {i18n.t('form_answers.answers_sidepanel.multiple_choice_label')}
      </Text.Normal>
      {options.map((option, index) => {
        const checked = selectedOptions.some((x) => x.id === option.id)
        return (
          <Box key={option.id} justifyContent="flexStart" flexDirection="row">
            <Box
              flexDirection="row"
              padding="s12"
              gap="s8"
              alignItems="center"
              cursor="pointer"
              background="white"
              border={{
                all: {
                  width: 's1',
                  style: 'solid',
                  color: 'grey300',
                },
              }}
              borderRadius={{
                all: 'abs008',
              }}
              style={{ width: '60%' }}
            >
              <Checkbox
                size="medium"
                onChange={() => {}}
                value={option.label}
                disabled
                checked={checked}
              />
              <Text.Normal size="200">{option.label}</Text.Normal>
            </Box>
            {mandatory && index === 0 && (
              <Box paddingLeft="s8">
                <Tooltip.Alt
                  attachment="bottom center"
                  toggle={setOpenTooltip}
                  open={openTooltip}
                  label={i18n.t('common.missing_field')}
                >
                  <Box aria-label={i18n.t('common.missing_field')}>
                    <Icon.Small icon="alert" encircled="grey800" />
                  </Box>
                </Tooltip.Alt>
              </Box>
            )}
          </Box>
        )
      })}
    </Box>
  )
}
